import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'truncateText' })

export class TruncateTextPipe implements PipeTransform {
    transform(text: string, length: number): string {

        if (text) {
            const truncatedText = text && `${text.substring(0, length)}`;
            return truncatedText.length === length ? `${truncatedText}...` : truncatedText;
        }
        else
            return text;
    }
}
